var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.1406 3.04688H18.332V2.28516C18.332 1.02512 17.3069 0 16.0469 0H9.95312C8.69309 0 7.66797 1.02512 7.66797 2.28516V3.04688H3.85938C2.59934 3.04688 1.57422 4.072 1.57422 5.33203C1.57422 6.344 2.23564 7.20388 3.14869 7.50349L4.50734 23.9046C4.6052 25.0796 5.60549 26 6.78458 26H19.2154C20.3946 26 21.3949 25.0796 21.4928 23.9042L22.8513 7.50344C23.7644 7.20388 24.4258 6.344 24.4258 5.33203C24.4258 4.072 23.4007 3.04688 22.1406 3.04688ZM9.19141 2.28516C9.19141 1.86514 9.53311 1.52344 9.95312 1.52344H16.0469C16.4669 1.52344 16.8086 1.86514 16.8086 2.28516V3.04688H9.19141V2.28516ZM19.9745 23.7781C19.9418 24.1697 19.6085 24.4766 19.2154 24.4766H6.78458C6.39158 24.4766 6.05815 24.1697 6.0256 23.7785L4.6868 7.61719H21.3132L19.9745 23.7781ZM22.1406 6.09375H3.85938C3.43936 6.09375 3.09766 5.75204 3.09766 5.33203C3.09766 4.91202 3.43936 4.57031 3.85938 4.57031H22.1406C22.5606 4.57031 22.9023 4.91202 22.9023 5.33203C22.9023 5.75204 22.5606 6.09375 22.1406 6.09375Z",
    fill: "#868686"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.95171 22.1443L9.18999 9.85524C9.16394 9.43533 8.8005 9.11597 8.38262 9.14212C7.96271 9.16817 7.64345 9.52964 7.66945 9.94949L8.43117 22.2386C8.4562 22.6425 8.79156 22.9532 9.1907 22.9532C9.63184 22.9532 9.97878 22.5817 9.95171 22.1443Z",
    fill: "#868686"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13 9.14062C12.5793 9.14062 12.2383 9.48167 12.2383 9.90234V22.1914C12.2383 22.6121 12.5793 22.9531 13 22.9531C13.4207 22.9531 13.7617 22.6121 13.7617 22.1914V9.90234C13.7617 9.48167 13.4207 9.14062 13 9.14062Z",
    fill: "#868686"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.6174 9.14211C17.1985 9.11606 16.8361 9.43532 16.8101 9.85523L16.0484 22.1443C16.0224 22.5642 16.3417 22.9256 16.7615 22.9517C17.1816 22.9777 17.5429 22.6583 17.5689 22.2385L18.3306 9.94948C18.3566 9.52957 18.0374 9.16811 17.6174 9.14211Z",
    fill: "#868686"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.82f8c6e762665641176655b9ccdcaec2.svg";
export { ForwardRef as ReactComponent };